module.exports = __webpack_public_path__ + "img/home_header_mask.c93cfc8e.png";